<div class="terms-wrapper">
  <div class="terms-container">
    <h1>PRIVACY POLICY</h1>
    <p class="sub-text"><strong>Platform:</strong> Coinwush</p>
    <p class="sub-text"><strong>Version:</strong> 1.0</p>

    <p class="sub-text"><strong>Last Updated:</strong> {{ lastUpdated }}</p>

    <p>
      This document constitutes a computer-generated electronic record under
      Rule 3 of the Information Technology (Intermediary Guidelines and Digital
      Media Ethics Code) Rules, 2021, as amended from time to time. Being
      electronically generated, it does not require any physical or digital
      signature.
    </p>

    <p>
      <strong>QUESTALIOUS PRIVATE LIMITED</strong> ("Company", "we", "us", or
      "our"), a company incorporated under the Companies Act, 2013 with
      Corporate Identification Number U63119UP2025PTC222413, operates a
      derivative trading platform under the brand name Coinwush.<br />
      The Company offers Virtual Digital Asset (VDA) derivative trading services
      through its official website
      <a href="https://coinwush.com" target="_blank">https://coinwush.com</a>
      and associated mobile applications (collectively, the "Platform").
    </p>

    <p>
      This Privacy Policy ("Policy") forms an integral part of the Coinwush
      Terms of Use and governs the collection, use, processing, storage,
      disclosure, and protection of your Personal Data. Capitalized terms used
      but not defined in this Privacy Policy shall have the meaning ascribed to
      them in the Terms of Use.
    </p>

    <p>
      If you do not agree with any part of this Privacy Policy, you must
      immediately discontinue access to and use of the Platform and Services.
    </p>

    <!-- Risk Disclaimer -->
    <div class="consent-declaration-box">
      <p>
        <strong>
          BY ACCESSING OR USING OUR PLATFORM, OR BY REGISTERING AN ACCOUNT WITH
          US, YOU ACKNOWLEDGE THAT THIS POLICY CONSTITUTES A BINDING LEGAL
          AGREEMENT BETWEEN YOU AND US. YOU HEREBY PROVIDE YOUR FREE, INFORMED,
          SPECIFIC, UNAMBIGUOUS, AND VOLUNTARY CONSENT TO THE COLLECTION, USE,
          ACCESS, PROCESSING, STORAGE, DISCLOSURE, TRANSFER, AND PROTECTION OF
          YOUR PERSONAL DATA IN ACCORDANCE WITH THIS POLICY AND FOR THE PURPOSES
          STATED HEREIN. IF YOU DO NOT AGREE OR UNDERSTAND THE CONTENTS OF THIS
          POLICY, YOU ARE ADVISED NOT TO PROCEED WITH THE USE OF OUR PLATFORM.
          YOU RETAIN THE RIGHT TO WITHHOLD OR WITHDRAW YOUR CONSENT AT ANY TIME
          BY INFORMING US IN WRITING, ALTHOUGH SUCH WITHDRAWAL MAY IMPACT YOUR
          CONTINUED ACCESS TO THE SERVICES.
        </strong>
      </p>
    </div>
    <!-- Sections -->
    <section>
      <h2>1. Definitions And Key Terms</h2>

      <p>
        For the purposes of this Privacy Policy, the following terms shall have
        the meanings set forth below:
      </p>

      <ol>
        <li>
          <strong>"Data Protection Law"</strong> means all applicable data
          protection, data security, and privacy laws governing the Company,
          including but not limited to the Information Technology Act, 2000 and
          its associated rules and regulations (including the Information
          Technology (Reasonable Security Practices and Procedures and Sensitive
          Personal Data or Information) Rules, 2011), the Digital Personal Data
          Protection Act, 2023 (once in force), and any other laws regulating
          the collection, storage, use, transmission, or disclosure of Personal
          Data.
        </li>

        <li>
          <strong>"Personal Data"</strong> means any information that relates to
          an identified or identifiable natural person. This includes data that
          directly identifies an individual (such as name, identification
          number, email address, or telephone number) or indirectly identifies
          them (such as date of birth, IP address, device identifiers, or online
          identifiers). It encompasses any information classified as "personal
          data" or "personal information" under applicable Data Protection Law.
        </li>

        <li>
          <strong>"Sensitive Personal Data or Information"</strong> means
          Personal Data that includes:
          <ol type="a">
            <li>
              Financial information such as bank account details, unified
              payment interface (UPI) identifiers, credit or debit card numbers,
              or other payment instrument details;
            </li>
            <li>Passwords and authentication credentials;</li>
            <li>Biometric information, including facial recognition data;</li>
            <li>Physical, physiological, or mental health conditions;</li>
            <li>Medical records or health history;</li>
            <li>Sexual orientation; and</li>
            <li>
              Any such data received, processed, or stored by us under lawful
              contract or as otherwise permitted by applicable Data Protection
              Law.
            </li>
          </ol>
        </li>

        <li>
          <strong>"Services"</strong> means the Virtual Digital Asset derivative
          trading services, including perpetual futures contracts and options
          contracts, offered by the Company on the Platform.
        </li>
      </ol>
    </section>
    <section>
      <h2>2. Information We Collect, USE, STORE, DISCLOSE, AND PROCESS</h2>

      <p>
        We may collect, use, store, disclose, and process the following
        categories of information about you:
      </p>

      <p>
        <strong>2.1 Information You Provide to Us</strong>
      </p>

      <p>
        You may be required to provide Personal Data (including Sensitive
        Personal Data or Information) while creating a user account or during
        ongoing use of our Platform. You agree to provide accurate, up-to-date
        information. This may include:
      </p>

      <ol>
        <li>
          <strong>Identification Details:</strong>
          Full name, date of birth, nationality, gender, photograph, and other
          identity verification information used to create and verify your
          profile.
        </li>

        <li>
          <strong>National Identifiers:</strong>
          Government-issued identification numbers including Permanent Account
          Number (PAN), Aadhaar number (provided voluntarily and used only for
          identity verification in accordance with applicable laws), passport
          number, voter ID, or driver's license details, for linking your
          identity with your registered profile.
        </li>

        <li>
          <strong>Contact Information:</strong>
          Email address, mobile phone number, and postal address, used for
          communication, support, and service delivery.
        </li>

        <li>
          <strong>Financial Information:</strong>
          Bank account details including account number, IFSC code, UPI
          identifiers, transaction history, source of funds declarations, income
          range, occupation details, and tax-related information (PAN), used for
          transaction processing and regulatory compliance.
        </li>

        <li>
          <strong>KYC and Verification Documents:</strong>
          Documents and information required for Know Your Customer (KYC)
          verification under applicable law, including:
          <ol type="a">
            <li>Live photograph captured during video KYC verification;</li>
            <li>Copies of government-issued identification documents;</li>
            <li>
              Geolocation data (latitude and longitude) at the time of KYC
              verification; and
            </li>
          </ol>
        </li>

        <li>
          <strong>Enhanced Due Diligence Information:</strong>
          For users classified as high-risk or engaging in high-value derivative
          trading, we may collect additional verification documents including:
          <ol type="a">
            <li>
              Bank statements or financial records to verify source of funds;
            </li>
            <li>Income Tax Returns (ITR);</li>
            <li>
              Proof of employment (salary slips, employment certificates) or
              business ownership documentation; and
            </li>
            <li>Wealth declarations or net worth statements.</li>
          </ol>
        </li>

        <li>
          <strong>Transaction and Trading Data:</strong>
          Details of derivative transactions including contract type (perpetual
          futures, options), position size, leverage utilized, margin deposits
          and withdrawals, profit and loss statements, liquidation events,
          timestamps, and complete trading history.
        </li>

        <li>
          <strong>Communications:</strong>
          Information shared during support interactions, surveys, feedback
          forms, legal investigations, or general queries.
        </li>
      </ol>
    </section>

    <section>
      <p>
        <strong>2.2 Information We Collect Automatically</strong>
      </p>

      <p>
        When you use our Platform, we automatically collect certain technical
        and behavioral data, including:
      </p>

      <ol>
        <li>
          <strong>Device and Technical Information:</strong>
          IP address, browser type and version.
        </li>

        <li>
          <strong>Device Permissions:</strong>
          Our mobile applications may request access to device features subject
          to your permission settings, including:
          <ol type="a">
            <li>Camera (for KYC verification and document scanning);</li>
            <li>Storage (for saving documents and images locally);</li>
            <li>
              Location services (for compliance and fraud prevention); and
            </li>
            <li>
              Notifications (for price alerts, margin calls, and liquidation
              warnings).
            </li>
          </ol>
        </li>

        <li>
          <strong>Usage Data:</strong>
          Pages visited, URLs accessed, timestamps, trade and transaction
          attempts, search activity, page interactions (scrolls, clicks,
          navigation patterns), session duration, response times, and error
          logs.
        </li>

        <li>
          <strong>Location Data:</strong>
          Precise or approximate geographic location data obtained through GPS,
          Wi-Fi, mobile network triangulation, or IP address geolocation, used
          for regulatory compliance, fraud detection, and service provision.
        </li>
        <li>
          <strong>Cookies and Tracking Technologies:</strong>
          Our website may use cookies and similar tracking technologies to
          improve user experience, maintain session security, analyze platform
          usage, and enhance platform performance. You may manage cookie
          preferences through your browser settings.
        </li>
      </ol>

      <p>
        <strong>2.3 Information from Third Parties</strong>
      </p>

      <p>We may receive data from third-party sources, including:</p>

      <ol>
        <li>
          <strong>KYC Service Providers:</strong>
          Identity verification data from our KYC partner Digio, including
          verification status, document authenticity checks, and facial
          recognition matching results.
        </li>

        <li>
          <strong>Public Databases and Registries:</strong>
          Information from government databases, credit bureaus, public records,
          and other legally accessible sources used for identity verification
          and due diligence.
        </li>

        <li>
          <strong>Service Providers:</strong>
          Technical and operational data from our cloud hosting provider
          Hostinger and other service providers engaged for platform operation
          and maintenance.
        </li>
      </ol>

      <p>
        <strong>Disclaimer:</strong>
        We collect only the Personal Data necessary to provide our Services,
        including KYC verification, transaction processing, derivative trading
        facilitation, risk management, fraud prevention, regulatory compliance,
        and personalized user experience. Any new purpose for data processing
        not listed here will require your explicit consent, obtained through a
        clear and separate request.
      </p>
    </section>

    <section>
      <h2>3. LEGAL BASIS AND PURPOSES FOR DATA PROCESSING</h2>

      <p><strong>3.1 Legal Basis for Processing</strong></p>

      <p>
        We process your Personal Data lawfully, fairly, and transparently, and
        only for specific, explicit, and legitimate purposes. The legal basis
        for processing your Personal Data depends on the nature and context of
        our engagement with you and may include one or more of the following:
      </p>

      <ol>
        <li>
          <strong>Contractual Necessity:</strong>
          To fulfill our contractual obligations under our agreement with you,
          including providing the Services you request, processing derivative
          transactions, managing your account, and enabling platform
          functionality.
        </li>

        <li>
          <strong>Legal Obligation:</strong>
          To comply with applicable legal and regulatory obligations in India,
          including but not limited to obligations under the Information
          Technology Act, 2000, the Prevention of Money Laundering Act, 2002
          (PMLA), the Income Tax Act, 1961, and guidelines issued by the
          Financial Intelligence Unit – India (FIU-IND), Reserve Bank of India,
          Securities and Exchange Board of India, and other statutory
          authorities and regulators.
        </li>

        <li>
          <strong>Legitimate Interests:</strong>
          To serve our legitimate business interests, such as enhancing user
          experience, improving our Services, preventing fraud, ensuring
          platform security, conducting risk assessments, and communicating with
          you regarding Coinwush updates and service information—provided this
          does not override your fundamental rights or freedoms.
        </li>

        <li>
          <strong>Consent:</strong>
          Based on your explicit and informed consent, which we may seek from
          you periodically for specific purposes where required by law or for
          processing that does not fall under the above categories. You may
          withdraw your consent at any time, subject to the provisions in
          Section 9 of this Policy.
        </li>
      </ol>

      <p>
        Sharing your Personal Data with us is voluntary; however, if you choose
        not to provide certain requested information, we may not be able to
        deliver some or all of our Services effectively, including the ability
        to open an account, conduct KYC verification, execute derivative trades,
        or comply with our regulatory obligations.
      </p>

      <p><strong>3.2 Purposes of Data Use</strong></p>

      <p>
        By providing your consent under this Policy, you authorize us to
        collect, use, copy, transmit, process, disclose, store, and back up your
        Personal Data and Sensitive Personal Data or Information for the
        purposes of delivering our Services and for the additional purposes
        outlined below:
      </p>

      <ol>
        <li>
          To operate and administer our Platform and provide derivative trading
          services;
        </li>

        <li>
          To create and manage your user account, maintain your profile, and
          authenticate your identity;
        </li>

        <li>
          To facilitate the use of features and services offered via our
          Platform, including execution of perpetual futures contracts, options
          contracts, and other derivative instruments;
        </li>

        <li>
          To process derivative transactions, calculate and collect margin
          requirements, monitor open positions, execute automatic liquidations
          when maintenance margin thresholds are breached, and settle contracts
          on a cash basis in Indian Rupees (INR);
        </li>

        <li>
          To fulfill our contractual obligations under any agreement between you
          and the Company;
        </li>

        <li>
          To perform KYC verification, including video KYC, face verification
          using biometric data, document authentication, and identity validation
          in accordance with Prevention of Money Laundering Act, 2002 and
          FIU-IND guidelines;
        </li>

        <li>
          To conduct enhanced due diligence for high-risk users or high-value
          derivative traders, including verification of source of funds,
          financial capacity assessment, and ongoing transaction monitoring;
        </li>

        <li>
          To categorize users based on risk profile (low, medium, or high risk)
          in accordance with our risk-based approach to anti-money laundering
          and counter-terrorist financing compliance;
        </li>

        <li>
          To detect, prevent, investigate, and report suspicious or illegal
          activities, including money laundering, terrorist financing, fraud,
          market manipulation, and other financial crimes, and to comply with
          our legal obligations to report such activities to FIU-IND and other
          authorities;
        </li>

        <li>
          To enforce our legal rights, including collection of outstanding
          amounts, enforcement of Terms of Use, and protection against breach of
          contract;
        </li>

        <li>
          To address inquiries, concerns, and complaints, and to provide
          customer support;
        </li>

        <li>
          To send push notifications regarding price movements, margin
          requirements, margin calls, approaching liquidation thresholds,
          completed liquidations, and other time-sensitive trading alerts;
        </li>

        <li>
          To provide information on platform updates, new features, service
          improvements, and important notices regarding your account or the
          Services;
        </li>

        <li>
          To improve and personalize our Services, ensure Platform security
          through risk monitoring and fraud detection, and enhance your overall
          user experience;
        </li>

        <li>
          To conduct internal research and analysis of user demographics,
          trading behavior, and platform usage patterns to better understand and
          serve our users;
        </li>

        <li>
          To comply with tax reporting obligations, including maintenance and
          reporting of transaction data to the Income Tax Department as required
          by law;
        </li>

        <li>
          To enable us to proactively communicate with law enforcement agencies,
          regulatory authorities, or any other government or judicial body in
          connection with suspicious activities, legal investigations, or
          compliance with lawful requests;
        </li>

        <li>
          To perform any other activities as required or authorized under
          applicable laws; and
        </li>

        <li>
          For any other purpose for which we seek and obtain your explicit
          consent.
        </li>
      </ol>

      <p>
        <strong>Important Notice:</strong>
        We are not responsible for the authenticity of any Personal Data,
        Sensitive Personal Data or Information, or other identification
        information provided by you or any third party acting on your behalf.
        You are solely responsible for ensuring that all information provided to
        us is accurate, current, and complete.
      </p>
    </section>

    <section>
      <h2>4. DISCLOSURE AND SHARING OF YOUR INFORMATION</h2>

      <p>
        You consent to the disclosure and sharing of your Personal Data with
        third parties in accordance with this Policy. This includes data you
        provide directly, as well as information received from third parties
        based on your prior authorization.
      </p>
      <p>
        We do not sell, rent, or trade your Personal Data to third parties for
        marketing purposes. Personal Data is shared only with service providers
        and authorities where necessary for providing the Services, identity
        verification, fraud prevention, legal compliance, and platform
        operations.
      </p>

      <p><strong>4.1 Categories of Recipients</strong></p>

      <p>
        We may disclose your Personal Data to the following categories of
        recipients:
      </p>

      <ol>
        <li>
          <strong>Service Providers:</strong>
          Third-party service providers who assist us in delivering our
          Services, including our KYC verification partner Digio for identity
          verification and video KYC services, and Hostinger for cloud hosting
          and data storage services. These service providers have limited access
          to your Personal Data strictly to the extent necessary for performing
          their functions and are contractually bound to protect the
          confidentiality of your information in accordance with applicable
          laws.
        </li>

        <li>
          <strong>Affiliated Entities:</strong>
          Our parent company, subsidiaries, affiliates, and other group entities
          with whom we may share information for legitimate business purposes,
          including platform operations, risk management, and compliance
          activities.
        </li>

        <li>
          <strong>Legal and Regulatory Authorities:</strong>
          Government authorities, regulatory agencies (including FIU-IND,
          Reserve Bank of India, Securities and Exchange Board of India, and
          Income Tax Department), law enforcement agencies, courts, tribunals,
          and other public authorities when required by law or necessary to:
          <ol type="a">
            <li>
              Comply with legal obligations, including reporting of suspicious
              transactions, high-value transactions, and cross-border
              transactions under PMLA;
            </li>
            <li>
              Respond to lawful requests, court orders, summons, or legal
              processes;
            </li>
            <li>Establish, exercise, or defend legal claims; and</li>
            <li>
              Protect the rights, property, or safety of the Company, our users,
              or the public.
            </li>
          </ol>
        </li>

        <li>
          <strong>Professional Advisors:</strong>
          Lawyers, accountants, auditors, consultants, and other professional
          advisors who provide services to us and are bound by confidentiality
          obligations.
        </li>

        <li>
          <strong>Corporate Transaction Participants:</strong>
          In the event of a merger, acquisition, sale of assets, reorganization,
          or other business transaction, your Personal Data may be transferred
          to the relevant third party. Should such a transfer occur, we or the
          successor entity shall obtain your prior consent if the transfer would
          result in your data being governed by a different privacy policy that
          materially changes how your information is processed.
        </li>

        <li>
          <strong>Other Parties with Your Consent:</strong>
          Any other third parties to whom you have directed or consented to
          share your information.
        </li>
      </ol>

      <p><strong>4.2 Aggregated and Anonymized Data</strong></p>

      <p>
        We may use, share, and disclose aggregated, anonymized, and non-personal
        information that does not identify you personally for various business
        purposes, including regulatory compliance, market analysis,
        benchmarking, research, and platform improvement. Such aggregated data
        does not constitute Personal Data under applicable Data Protection Law.
      </p>

      <p><strong>4.3 Third-Party Websites and Services</strong></p>

      <p>
        Our Platform may contain links to third-party websites or services. By
        accessing these links, you may be redirected to external platforms that
        are not owned, operated, or controlled by us. We do not take
        responsibility for the content, privacy practices, or operations of such
        third-party platforms. Interactions with these platforms may involve
        sharing your Personal Data directly with them. These third parties may
        handle your Personal Data in accordance with their own privacy policies
        and terms, which we strongly advise you to review carefully before
        providing any information. You acknowledge and agree that we are not
        liable for any loss of privacy, misuse of Personal Data, or other
        damages arising from your use of or reliance on such third-party
        websites or services.
      </p>
    </section>

    <section>
      <h2>5. KNOW YOUR CUSTOMER (KYC) AND ENHANCED DUE DILIGENCE</h2>

      <p><strong>5.1 Mandatory KYC Requirements</strong></p>

      <p>
        To use our derivative trading Services, you must complete our KYC
        verification process in accordance with the Prevention of Money
        Laundering Act, 2002 (PMLA) and rules made thereunder. We retain the
        right to not provide Services or suspend your user account if we
        identify any deficiency in the identity verification or due diligence
        process.
      </p>

      <p>
        By accessing and using our Platform, you hereby declare and represent
        that you are a resident of India under the applicable laws of India and
        are at least 18 years of age.
      </p>

      <p>
        As an individual user, you will be required to submit the following
        information and documents:
      </p>

      <ol type="a">
        <li>Full legal name as per government-issued identification;</li>
        <li>Date of birth, gender, and nationality;</li>
        <li>
          Permanent Account Number (PAN) issued by the Income Tax Department of
          India;
        </li>
        <li>Residential address with supporting proof;</li>
        <li>Email address and mobile telephone number;</li>
        <li>
          Government-issued photo identification document (Aadhaar, Passport,
          Voter ID, or Driver's License);
        </li>
        <li>Live photograph captured during video KYC session;</li>
        <li>
          Geolocation data (GPS coordinates) at the time of KYC verification;
        </li>
        <li>Occupation and income range; and</li>
        <li>Source of funds declaration.</li>
      </ol>

      <p>
        You hereby explicitly consent for us to, directly or through our
        third-party KYC service provider Digio, make any inquiries as mandated
        under relevant law or as we consider necessary to verify your identity.
        You hereby confirm that you will assist Digio and us in carrying out the
        verification process, including participating in video KYC sessions and
        providing all required documentation.
      </p>

      <p><strong>5.2 Video KYC and Biometric Verification</strong></p>

      <p>
        Our KYC process includes mandatory video verification conducted through
        our authorized KYC partner Digio. During this process:
      </p>

      <ol type="a">
        <li>
          Your live photograph will be captured and compared against your
          government-issued identification document;
        </li>
        <li>
          Facial biometric data will be processed for identity verification
          purposes;
        </li>
        <li>
          Your precise geolocation (latitude and longitude) will be recorded at
          the time of verification;
        </li>
        <li>
          The video KYC session may be recorded for compliance and audit
          purposes; and
        </li>
        <li>
          Document authenticity checks will be performed on your submitted
          identification documents.
        </li>
      </ol>

      <p>
        By proceeding with video KYC, you provide your explicit consent to the
        collection, processing, and storage of your facial biometric data and
        video recordings for the purposes of identity verification, fraud
        prevention, and regulatory compliance.
      </p>

      <p><strong>5.3 Enhanced Due Diligence for High-Risk Users</strong></p>

      <p>
        We employ a risk-based approach to customer due diligence. Users may be
        classified as low, medium, or high risk based on factors including but
        not limited to:
      </p>

      <ol type="a">
        <li>Transaction volume and frequency;</li>
        <li>Derivative trading patterns and leverage utilization;</li>
        <li>Source of funds and financial capacity;</li>
        <li>Geographic location and transaction counterparties; and</li>
        <li>
          Other risk indicators identified through our compliance monitoring
          systems.
        </li>
      </ol>

      <p>
        For users classified as high-risk or engaging in high-value derivative
        trading, we may conduct enhanced due diligence measures, which may
        include requesting additional documentation such as:
      </p>

      <ol type="a">
        <li>Bank statements or financial records to verify source of funds;</li>
        <li>
          Income Tax Returns (ITR) from the Income Tax Department of India;
        </li>
        <li>
          Proof of employment (salary slips, employment certificates) or
          business ownership documentation (business registration certificates,
          GST registration, financial statements);
        </li>
        <li>Wealth declarations or net worth statements; and</li>
        <li>
          Any other documents or information we deem necessary to assess your
          financial capacity and verify the legitimacy of your trading
          activities.
        </li>
      </ol>

      <p>
        Enhanced due diligence measures will also include ongoing monitoring of
        your transaction patterns, periodic review of your risk classification,
        and additional verification procedures for transactions that exceed
        specified thresholds or exhibit unusual characteristics.
      </p>

      <p><strong>5.4 Customer Acceptance Policy</strong></p>

      <p>
        We maintain strict customer acceptance standards in accordance with PMLA
        requirements:
      </p>

      <ol type="a">
        <li>
          We do not open accounts or provide Services to users who register with
          anonymous, fictitious, or benami names;
        </li>
        <li>
          We do not open accounts or provide Services to users for whom we
          cannot complete the identity verification and due diligence process,
          either due to non-cooperation by the user or non-reliability of the
          documents or information furnished;
        </li>
        <li>
          You will not have access to our Services until the identity
          verification and due diligence process has been completed
          satisfactorily;
        </li>
        <li>
          We do not open joint accounts or allow multiple individuals to operate
          a single account. Each account must be operated, controlled, and used
          solely by the registered account holder; and
        </li>
        <li>
          We reserve the right not to carry out identity verification and due
          diligence where we have reason to believe that the user is engaging in
          money laundering or terrorist financing, and instead we will report
          such suspicions to the appropriate law enforcement authorities as
          required by law.
        </li>
      </ol>

      <p><strong>5.5 Maintenance of Records</strong></p>

      <p>
        We will maintain a record of transactions in a manner enabling us to
        reconstruct individual transactions and records of documents evidencing
        your identity and account files and business correspondence relating to
        you. We shall maintain records as required under the Prevention of Money
        Laundering Act, 2002 and the Prevention of Money Laundering (Maintenance
        of Records) Rules, 2005.
      </p>

      <p><strong>5.6 Responsibility for Account Activities</strong></p>

      <p>
        You will be bound by, and hereby authorize us to accept and rely on, any
        agreements, instructions, orders, authorizations and any other actions
        made, provided or taken by anyone who has accessed or used your user
        account regardless of whether the access is authorized or unauthorized.
        Upon receipt of written notice from you that the security of your user
        account has been compromised, we will take reasonable steps to protect
        your user account. We shall, under no circumstance, be liable for any
        loss incurred by you by any unauthorized use of your user account.
      </p>
    </section>

    <section>
      <h2>6. DATA SECURITY MEASURES</h2>

      <ol>
        <li>
          We have implemented commercially reasonable technical, organizational,
          and physical security measures to prevent unlawful access to,
          accidental loss of, or unauthorized modification of Personal Data,
          including those prescribed under applicable Data Protection Law. These
          measures include firewalls, encryption (both in transit and at rest),
          access controls, secure authentication mechanisms, regular security
          assessments, and disaster recovery plans.
        </li>

        <li>
          All Personal Data and Sensitive Personal Data or Information you
          provide to us is stored on secure servers operated by our cloud
          hosting provider Hostinger, with servers located within the
          territorial jurisdiction of India. We do not transfer Sensitive
          Personal Data or Information, KYC documents, or biometric data outside
          India.
        </li>

        <li>
          We restrict access to your Personal Data to our employees,
          contractors, and service providers on a need-to-know basis. All
          personnel with access to Personal Data are subject to confidentiality
          obligations and are required to process your data only in accordance
          with our instructions.
        </li>

        <li>
          We strongly recommend that you protect your account credentials and
          passwords. Do not share your password with anyone, use strong and
          unique passwords, enable two-factor authentication if available, and
          follow general internet security best practices. In public areas,
          exercise caution and do not leave your device unattended while logged
          into your account. We recommend the use of established malware and
          antivirus protection software on your devices.
        </li>

        <li>
          If you suspect any misuse, loss of, or unauthorized access to your
          Personal Data or account credentials, please notify us immediately at
          the contact details provided in Section 12 of this Policy. We will
          investigate the matter and take appropriate action in accordance with
          our incident response procedures.
        </li>

        <li>
          Notwithstanding our security measures, you understand and acknowledge
          that no method of transmission over the internet or method of
          electronic storage is completely secure. Any transmission of Personal
          Data through the internet is at your own risk. While we strive to
          protect your Personal Data, we cannot guarantee absolute security and
          hereby disclaim all liability for any breach of security, malicious
          attacks, errors, omissions, or unauthorized access, except where such
          breach has been caused as a direct result of our gross negligence or
          willful default.
        </li>

        <li>
          In the event of a data breach that is likely to result in risk to your
          rights and freedoms, we will notify you and the relevant regulatory
          authorities in accordance with applicable Data Protection Law and
          within the timelines prescribed by such laws.
        </li>
      </ol>
    </section>

    <section>
      <h2>7. DATA RETENTION AND STORAGE</h2>

      <p>
        We retain your Personal Data for the duration that your user account
        remains active and for an additional period as mandated by applicable
        laws following account closure or cessation of Services.
      </p>

      <p><strong>7.1 Statutory Retention Requirements</strong></p>

      <ol>
        <li>
          <strong>KYC and Transaction Records:</strong>
          In accordance with the Prevention of Money Laundering Act, 2002 (PMLA)
          and the Prevention of Money Laundering (Maintenance of Records) Rules,
          2005, we retain the following records for a minimum period of ten (10)
          years from the date of cessation of your relationship with us or from
          the date of the last transaction, whichever is later:
          <ol type="a">
            <li>
              All KYC documents and identity verification records, including
              government-issued identification documents, video KYC recordings,
              facial biometric data, and related verification reports;
            </li>
            <li>
              Complete transaction records, including all derivative trades
              (perpetual futures, options), margin deposits and withdrawals,
              liquidation events, profit and loss statements, and transaction
              timestamps;
            </li>
            <li>
              Account opening documentation, source of funds declarations,
              financial capacity assessments, and enhanced due diligence
              records;
            </li>
            <li>
              Records of transactions that exceed prescribed reporting
              thresholds;
            </li>
            <li>
              Suspicious transaction reports (STRs) and supporting
              documentation; and
            </li>
            <li>
              All correspondence and communications related to customer due
              diligence and ongoing monitoring.
            </li>
          </ol>
        </li>

        <li>
          <strong>Extended Retention:</strong>
          The retention period may be extended beyond ten (10) years where
          required by applicable law or for the following purposes:
          <ol type="a">
            <li>
              Resolution of disputes, litigation, arbitration proceedings, or
              regulatory investigations;
            </li>
            <li>Ongoing prosecutions or enforcement actions;</li>
            <li>
              Suspicious or illegal transactions requiring continued monitoring;
            </li>
            <li>
              Enforcement of contractual agreements and recovery of dues; and
            </li>
            <li>
              Protection of vital interests of you or another natural person.
            </li>
          </ol>
        </li>

        <li>
          <strong>Non-Critical Usage Data:</strong>
          Information such as browsing history, device logs, and activity
          patterns that are not subject to statutory retention requirements may
          be retained for a shorter period, typically up to two (2) years, to
          support operational analytics, platform improvements, and security
          monitoring.
        </li>
      </ol>

      <p><strong>7.2 Data Deletion and Anonymization</strong></p>

      <ol>
        <li>
          Upon expiration of the applicable retention period and subject to the
          provisions in Section 7.1(2) above, we will securely delete or
          anonymize your Personal Data using industry-standard data erasure
          techniques to ensure it is permanently unrecoverable and inaccessible
          to unauthorized parties.
        </li>

        <li>
          Upon account closure or termination, residual data may temporarily
          remain in backup systems, disaster recovery systems, or archival
          storage until such systems are refreshed or overwritten through normal
          technical processes. Such residual data is considered "beyond use,"
          meaning it is not accessible to our operational personnel and is not
          subject to active processing.
        </li>

        <li>
          We disclaim any liability for the availability, retrieval, or
          restoration of Personal Data after the expiry of the mandated
          retention period or following the closure or termination of your user
          account, except as specifically required by applicable law.
        </li>
      </ol>
    </section>

    <section>
      <h2>8. YOUR RIGHTS UNDER THIS PRIVACY POLICY</h2>

      <p>
        Subject to applicable Data Protection Law, you have the following rights
        with respect to your Personal Data:
      </p>

      <ol>
        <li>
          <strong>Right to Access:</strong>
          You have the right to verify whether we retain any of your Personal
          Data and to access such information. You may request a copy of your
          Personal Data in a structured, commonly used, and machine-readable
          format, where technically feasible.
        </li>

        <li>
          <strong>Right to Correction:</strong>
          You have the right to request correction of any inaccurate or
          incomplete Personal Data. Upon receiving written notice from you, we
          will rectify such information as soon as reasonably practicable,
          subject to verification of the corrected information.
        </li>

        <li>
          <strong>Right to Understand Our Practices:</strong>
          You have the right to understand our policies and practices relating
          to the handling of your Personal Data, including how we collect, use,
          disclose, store, and protect your information.
        </li>

        <li>
          <strong>Right to Withdraw Consent:</strong>
          Where processing is based on your consent, you have the right to
          withdraw your consent at any time. Withdrawal of consent does not
          affect the lawfulness of processing carried out prior to such
          withdrawal. To withdraw consent, please refer to Section 9 below.
        </li>

        <li>
          <strong>Right to File Complaints:</strong>
          You have the right to lodge complaints regarding the collection, use,
          disclosure, or security of your Personal Data through the contact
          details provided in Section 12 of this Policy.
        </li>
      </ol>

      <p>
        To exercise any of the above rights, you may submit a request using the
        contact information provided in Section 12. While most requests can be
        addressed promptly, complex inquiries may require additional time and
        effort. We reserve the right to verify your identity before processing
        your request and may charge a reasonable fee for processing manifestly
        unfounded, repetitive, or excessive requests, where permitted by
        applicable law.
      </p>

      <p>
        Please note that the Company may retain part or all of your Personal
        Data in accordance with its internal policies or as mandated by
        applicable Data Protection Law, particularly for the purposes outlined
        in Section 7 (Data Retention and Storage) of this Policy.
      </p>
    </section>

    <section>
      <h2>9. WITHDRAWAL OF CONSENT AND RESTRICTION OF DATA USE</h2>

      <p>
        You have the right to withdraw your consent for the processing of your
        Personal Data at any time. However, please note that we are unable to
        provide access to our Platform or Services without processing certain
        categories of Personal Data and Sensitive Personal Data or Information
        that are necessary for:
      </p>

      <ol type="a">
        <li>Identity verification and KYC compliance;</li>
        <li>Execution and settlement of derivative transactions;</li>
        <li>Margin management and risk monitoring;</li>
        <li>Regulatory compliance under PMLA and other applicable laws; and</li>
        <li>Platform security and fraud prevention.</li>
      </ol>

      <p>
        To withdraw your consent for data processing, please send a written
        request to the contact details provided in Section 12, using your
        registered email address and including your user ID. We will acknowledge
        your request within forty-eight (48) hours and process it within seven
        (7) business days, unless we are required by law to continue processing
        your Personal Data.
      </p>

      <p>Withdrawal of consent may result in:</p>

      <ol type="a">
        <li>
          Restricted access to certain Services, including the inability to
          execute new derivative trades, access trading features, or use wallet
          functionality;
        </li>
        <li>Closure or suspension of your user account; and</li>
        <li>
          Inability to access certain features or receive certain communications
          from us.
        </li>
      </ol>

      <p>
        Please note that withdrawal of consent does not affect the legality of
        any data processing carried out based on consent provided prior to such
        withdrawal, nor does it affect our obligation to retain certain Personal
        Data for the statutory retention periods outlined in Section 7 of this
        Policy.
      </p>
    </section>

    <section>
      <h2>10. YOUR RESPONSIBILITIES AS A USER</h2>

      <p>By using our Platform and Services, you agree to:</p>

      <ol type="a">
        <li>
          Provide accurate, current, and complete information at all times,
          including during account registration, KYC verification, and ongoing
          use of our Services;
        </li>
        <li>
          Refrain from impersonating any individual or misrepresenting your
          identity when providing information to us;
        </li>
        <li>
          Avoid submitting any false, fraudulent, frivolous, or misleading
          information, documents, or complaints;
        </li>
        <li>
          Promptly update any changes to your Personal Data, including changes
          to contact information, address, or financial details, by updating
          your account settings or contacting us;
        </li>
        <li>
          Maintain the confidentiality and security of your account credentials,
          passwords, and authentication methods;
        </li>
        <li>
          Not share your account access with any other person or allow any
          unauthorized person to use your account;
        </li>
        <li>
          Immediately notify us if you suspect any unauthorized access to your
          account or any security breach;
        </li>
        <li>
          Comply with all applicable laws, regulations, and the terms of this
          Privacy Policy and our Terms of Use at all times; and
        </li>
        <li>
          Accept full responsibility for all activities conducted through your
          user account, whether authorized or unauthorized.
        </li>
      </ol>

      <p>
        You acknowledge that you are solely responsible for the accuracy and
        completeness of the information you provide to us. We shall not be held
        liable for any consequences arising from your provision of inaccurate,
        incomplete, or misleading information.
      </p>
    </section>
    <section>
      <h2>11. AGE RESTRICTION AND ELIGIBILITY</h2>

      <p>
        Our Platform and Services are intended exclusively for individuals who
        are at least eighteen (18) years of age or above and are legally
        competent to enter into binding contracts under the laws of India.
      </p>

      <p>
        We do not knowingly collect, process, or store Personal Data from
        individuals below the age of eighteen (18) years. If you are under
        eighteen (18) years of age, you are not permitted to access or use our
        Platform or Services.
      </p>

      <p>
        If we discover that we have inadvertently collected Personal Data from
        an individual under the age of eighteen (18) years, we will delete such
        data immediately upon detection.
      </p>

      <p>
        By registering an account with us, you represent and warrant that you
        are at least eighteen (18) years of age and have the legal capacity to
        enter into this Privacy Policy and our Terms of Use. Age verification is
        conducted as part of our mandatory KYC process.
      </p>
    </section>

    <section>
      <h2>12. CONTACT INFORMATION AND NOTICES</h2>

      <p>
        If you have any questions, concerns, feedback, or complaints regarding
        this Privacy Policy, the collection, use, disclosure, or security of
        your Personal Data, or wish to exercise your data protection rights, you
        may contact us at:
      </p>

      <!-- <p>
        <strong>QUESTALIOUS PRIVATE LIMITED</strong><br />
        Registered Office Address: 155/101 Gali no.7, Hari Nagar, Kankerkhera
        Kanker Khera, Meerut, Uttar Pradesh – 250001 India<br />
        Platform:
        <a href="https://coinwush.com" target="_blank">https://coinwush.com</a>
      </p> -->
      <p>
        <strong>Data Protection Officer / Grievance Officer</strong><br />
        <strong>Email:</strong> compliance&#64;coinwush.com
      </p>
      <p>
        Please clearly mention "Privacy Policy" in the subject line of your
        communication and outline your concern or request with sufficient
        detail. You may attach supporting documentation where applicable.
      </p>
    </section>

    <section>
      <p><strong>12.1 How We Communicate With You</strong></p>

      <p>
        We may provide notices and communications to you through the following
        channels:
      </p>

      <ol type="a">
        <li>
          Email sent to the email address associated with your user account;
        </li>
        <li>In-app notifications and alerts through our Platform;</li>
        <li>
          Push notifications to your mobile device (subject to your device
          permission settings); and
        </li>
        <li>Posting of notices on our Platform or website.</li>
      </ol>

      <p>
        Notices provided by email will be effective when we send the email to
        your registered email address. It is your responsibility to maintain an
        active and current email address and to regularly check your email,
        including spam or junk folders.
      </p>

      <p>
        Notices sent by courier or registered mail to our registered office
        address will be effective one (1) business week after dispatch in the
        case of courier, or three (3) business days after dispatch in the case
        of registered mail.
      </p>
    </section>

    <section>
      <h2>13. UPDATES TO THIS PRIVACY POLICY</h2>

      <p>
        We may revise or update this Privacy Policy from time to time, as
        required by changes in applicable Data Protection Law, regulatory
        guidance, business operations, or service offerings.
      </p>

      <p>
        We will provide you with appropriate notice of any material changes to
        this Policy through one or more of the following methods:
      </p>

      <ol type="a">
        <li>Posting a prominent notice on our Platform or website;</li>
        <li>
          Sending an email notification to your registered email address; or
        </li>
        <li>
          Requiring you to acknowledge the updated Policy upon your next login
          to the Platform.
        </li>
      </ol>

      <p>
        The "Last Updated" date at the beginning of this Policy will be revised
        to reflect the date of the most recent modifications.
      </p>

      <p>
        We encourage you to review this Privacy Policy periodically to stay
        informed about our privacy practices and how we protect your Personal
        Data.
      </p>

      <p>
        Your continued use of our Platform and Services following the posting of
        any changes to this Privacy Policy shall be deemed as your acceptance of
        the revised Policy. If you do not agree with any part of this Privacy
        Policy, you must immediately discontinue access to and use of the
        Platform and Services.
      </p>
    </section>

    <section>
      <h2>14. GOVERNING LAW AND DISPUTE RESOLUTION</h2>

      <p>
        This Privacy Policy shall be governed by and construed in accordance
        with the laws of India, without regard to conflict of law principles.
      </p>

      <p>
        Any dispute, controversy, or claim arising out of or relating to this
        Privacy Policy, including its interpretation, breach, termination, or
        invalidity, shall first be attempted to be resolved through good faith
        negotiations between you and the Company.
      </p>

      <p>
        If such dispute cannot be resolved through negotiations within thirty
        (30) days, it shall be referred to and finally resolved by arbitration
        in accordance with the Arbitration and Conciliation Act, 1996. The
        arbitration shall be conducted:
      </p>

      <ol type="a">
        <li>
          By a sole arbitrator mutually appointed by both parties, or failing
          such agreement, appointed in accordance with the provisions of the
          Arbitration and Conciliation Act, 1996;
        </li>
        <li>In the English language; and</li>
        <!-- <li>At the seat of arbitration in Meerut, Uttar Pradesh, India.</li> -->
      </ol>

      <p>
        The arbitrator shall have exclusive authority to make all procedural and
        substantive decisions regarding the dispute and to grant any remedy that
        would otherwise be available in a court of law. The arbitration award
        shall be final and binding upon both parties.
      </p>

      <!-- <p>
        Subject to the arbitration clause above, the courts of Meerut, Uttar
        Pradesh, India shall have exclusive jurisdiction over any disputes
        arising under this Privacy Policy.
      </p> -->
    </section>

    <section>
      <h2>15. SEVERABILITY</h2>

      <p>
        If any provision of this Privacy Policy is determined to be invalid,
        void, or unenforceable by a court of competent jurisdiction, such
        determination shall not affect the validity or enforceability of the
        remaining provisions, which shall continue in full force and effect. The
        invalid or unenforceable provision shall be replaced with a valid and
        enforceable provision that most closely reflects the original intent of
        the parties.
      </p>
    </section>

    <section>
      <h2>16. COSTS AND FEES FOR EXERCISING DATA RIGHTS</h2>

      <p>
        We are committed to facilitating your rights under applicable Data
        Protection Law, including your right to access, correct, or obtain a
        copy of your Personal Data. These services are generally provided free
        of charge.
      </p>

      <p>
        However, in limited circumstances where a request is manifestly
        unfounded, repetitive in nature, excessive, or imposes a
        disproportionate administrative burden on us, we reserve the right to
        charge a reasonable fee to cover the actual cost of processing such
        requests.
      </p>

      <p>
        In such cases, you will be notified in advance about any applicable fee
        and the rationale behind it. You will have the opportunity to withdraw
        or modify your request if you choose not to proceed with the fee.
      </p>

      <p>
        We will never impose a fee merely for the purpose of deterring the
        exercise of your rights under applicable Data Protection Law.
      </p>
    </section>

    <section>
      <h2>17. FORCE MAJEURE</h2>

      <p>
        Notwithstanding anything contained in this Privacy Policy, we shall not
        be held liable for any loss, damage, or misuse of your Personal Data if
        it results from a Force Majeure Event, meaning any event or circumstance
        beyond our reasonable control, including but not limited to acts of God,
        natural disasters, war, terrorism, riots, embargoes, acts of civil or
        military authorities, fire, floods, earthquakes, accidents, network
        infrastructure failures, strikes, power failures, equipment or software
        malfunctions, pandemics, or any other unforeseeable events.
      </p>
    </section>

    <div class="acknowledgment-box">
      <p>
        <strong>
          BY USING OUR PLATFORM AND SERVICES, YOU ACKNOWLEDGE THAT YOU HAVE
          READ, UNDERSTOOD, AND AGREE TO BE BOUND BY THIS PRIVACY POLICY.
        </strong>
      </p>
    </div>

    <div class="footer-note">
      <!-- <p>
        Questalious Private Limited | CIN: U63119UP2025PTC222413<br />
        155/101, Gali No. 7, Hari Nagar, Kankerkhera, Meerut – 250001, Uttar
        Pradesh, India<br />
        Website: https://coinwush.com | Support: support&#64;coinwush.com
      </p>  -->
    </div>
  </div>
</div>
